export default __webpack_public_path__ + "static/beneficios-740b15ae8804a31c06c7f553fd2ec407.png";